import { useCallback, useMemo } from 'react';
import createPersistedState from 'use-persisted-state';
import { TEAM } from 'shared/constants/team';

// Names typed into the identity prompt, kept on this browser so someone who
// isn't in TEAM (a contractor, a shared machine) only has to say who they are
// once. TEAM stays the source of truth for the team itself; this only adds to it.
const KEY = 'sbly-tools:actor-names';
const useCustomNamesState = createPersistedState(KEY);

export default function useActorNames(): [string[], (name: string) => void] {
  const [custom, setCustom] = useCustomNamesState<string[]>([]);

  const names = useMemo(() => {
    const extra = (Array.isArray(custom) ? custom : []).filter(
      name => typeof name === 'string' && name && !TEAM.includes(name),
    );
    return [...TEAM, ...extra];
  }, [custom]);

  const remember = useCallback(
    (name: string) => {
      const trimmed = name.trim();
      if (!trimmed || TEAM.includes(trimmed)) return;
      setCustom(current => {
        const list = Array.isArray(current) ? current : [];
        return list.includes(trimmed) ? list : [...list, trimmed];
      });
    },
    [setCustom],
  );

  return [names, remember];
}
